import { connect } from "react-redux";
import WebBlocks from "../web-block/WebBlocks";


const Eventos = (props) => {

    return <WebBlocks group_slug="eventos" model="Evento"></WebBlocks>
}

export default connect(state => ({}))(Eventos);